import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhyUs() {
  return <section id="über uns" className="py-16 bg-gray-50" data-id="element-523">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-524">
        <div className="text-center" data-id="element-525">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-526">
            Warum wir?
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-527">
            Ihr Partner für sichere Praxen
          </p>
        </div>
        <div className="mt-12 lg:grid lg:grid-cols-2 lg:gap-8 items-center" data-id="element-528">
          <div data-id="element-529">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-530">
              neocube – Ihr IT-Systemhaus für Arztpraxen
            </h3>
            <div className="prose prose-blue text-gray-600" data-id="element-531">
              <p data-id="element-532">
                Als spezialisiertes IT-Systemhaus bieten wir mit unserem Produkt
                neocube.pro eine smarte All-in-One-Lösung für Anwälte, Ärzte,
                Zahnärzte und Bürogemeinschaften. Wir verstehen die besonderen
                Anforderungen von Arztpraxen und haben uns auf deren
                IT-Sicherheit spezialisiert.
              </p>
              <p data-id="element-533">
                Mit unserem §390 SGB V Readiness-Paket bieten wir Ihnen eine
                maßgeschneiderte Lösung, um alle neuen Sicherheitsrichtlinien
                rechtzeitig und vollständig umzusetzen. Unsere Experten prüfen
                Ihre bestehenden Systeme und implementieren alle notwendigen
                Maßnahmen, damit Sie sich auf Ihre Patienten konzentrieren
                können.
              </p>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-534">
              Unsere Expertise:
            </h4>
            <ul className="space-y-3" data-id="element-535">
              <li className="flex" data-id="element-536">
                <CheckCircleIcon className="h-6 w-6 text-blue-500 flex-shrink-0" data-id="element-537" />
                <span className="ml-3 text-gray-600" data-id="element-538">
                  Langjährige Erfahrung mit Arztpraxen und deren
                  IT-Anforderungen
                </span>
              </li>
              <li className="flex" data-id="element-539">
                <CheckCircleIcon className="h-6 w-6 text-blue-500 flex-shrink-0" data-id="element-540" />
                <span className="ml-3 text-gray-600" data-id="element-541">
                  Spezialisierung auf Datenschutz und IT-Sicherheit im
                  Gesundheitswesen
                </span>
              </li>
              <li className="flex" data-id="element-542">
                <CheckCircleIcon className="h-6 w-6 text-blue-500 flex-shrink-0" data-id="element-543" />
                <span className="ml-3 text-gray-600" data-id="element-544">
                  Erfahrung mit TI-Infrastruktur und praxisspezifischer Software
                </span>
              </li>
              <li className="flex" data-id="element-545">
                <CheckCircleIcon className="h-6 w-6 text-blue-500 flex-shrink-0" data-id="element-546" />
                <span className="ml-3 text-gray-600" data-id="element-547">
                  Cloud-Security-Experten mit umfassenden Zertifizierungen
                </span>
              </li>
              <li className="flex" data-id="element-548">
                <CheckCircleIcon className="h-6 w-6 text-blue-500 flex-shrink-0" data-id="element-549" />
                <span className="ml-3 text-gray-600" data-id="element-550">
                  Persönliche Betreuung durch feste Ansprechpartner
                </span>
              </li>
            </ul>
          </div>
          <div className="mt-10 lg:mt-0" data-id="element-551">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-552">
              <div className="px-6 py-8" data-id="element-553">
                <div className="flex items-center justify-center mb-6" data-id="element-554">
                  <div className="rounded-full bg-blue-100 p-3" data-id="element-555">
                    <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-556">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-557" />
                    </svg>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-center text-gray-900 mb-4" data-id="element-558">
                  Sichere Praxis 2026
                </h3>
                <div className="border-t border-gray-200 pt-4" data-id="element-559">
                  <blockquote className="italic text-gray-600 mb-6" data-id="element-560">
                    "Dank neocube war unsere Praxis innerhalb weniger Wochen
                    komplett § 390-ready. Das Team hat uns professionell beraten
                    und alle notwendigen Maßnahmen umgesetzt. Wir können uns
                    jetzt wieder voll auf unsere Patienten konzentrieren."
                  </blockquote>
                  <div className="text-right" data-id="element-561">
                    <p className="text-sm font-medium text-gray-900" data-id="element-562">
                      Dr. Notter
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-563">
                      Arztpraxis in München
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-blue-50 px-6 py-4" data-id="element-564">
                <div className="text-center" data-id="element-565">
                  <h4 className="font-medium text-gray-900" data-id="element-566">
                    Unsere Partner und Zertifizierungen:
                  </h4>
                  <div className="mt-4 flex justify-center space-x-6" data-id="element-567">
                    <div className="text-center" data-id="element-568">
                      <div className="h-10 w-10 mx-auto bg-blue-100 rounded-full flex items-center justify-center" data-id="element-569">
                        <span className="text-blue-600 font-bold" data-id="element-570">TI</span>
                      </div>
                      <p className="mt-2 text-xs text-gray-600" data-id="element-571">TI-Ready</p>
                    </div>
                    <div className="text-center" data-id="element-572">
                      <div className="h-10 w-10 mx-auto bg-blue-100 rounded-full flex items-center justify-center" data-id="element-573">
                        <span className="text-blue-600 font-bold" data-id="element-574">DS</span>
                      </div>
                      <p className="mt-2 text-xs text-gray-600" data-id="element-575">
                        DSGVO-konform
                      </p>
                    </div>
                    <div className="text-center" data-id="element-576">
                      <div className="h-10 w-10 mx-auto bg-blue-100 rounded-full flex items-center justify-center" data-id="element-577">
                        <span className="text-blue-600 font-bold" data-id="element-578">ISO</span>
                      </div>
                      <p className="mt-2 text-xs text-gray-600" data-id="element-579">ISO 27001</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}